import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { WordpressServiceExtended } from '../../services/wordpress.api.service';
import { loadFixedPages, loadFixedPagesFailure, loadFixedPagesSuccess } from './fixedPages.actions';


@Injectable()
export class FixedPagesEffects {

  loadFixedPages$ = createEffect(() => this.actions$.pipe(
    ofType(loadFixedPages),
    mergeMap((action) => this.wordpressServiceExtended.getFixedPages().pipe(
      map((response) => loadFixedPagesSuccess({data: response})),
      catchError(error => of(loadFixedPagesFailure(error))),
    )),
  ), {dispatch: true});


  constructor(
    private actions$: Actions,
    private router: Router,
    private wordpressServiceExtended: WordpressServiceExtended,
  ) {
  }
}
